/* GiftInOne: optional mobile drawer gestures; purchase controls stay independent. */
(function () {
  'use strict';
  if (window.GIOToolsDrawer) return;
  window.GIOToolsDrawer = {bind:function (options) {
    options=options||{};
    var main=options.main, pop=options.pop, side=options.side, handle=options.handle;
    var disposed=false, failed=false, applyingState=false, listeners=[], observer=null, lifecycleObserver=null;
    var resizeFrame=0, dragFrame=0, sizeKey='', lifecycleKey='', drag=null, suppressedClick=null, clickTimer=0;
    var empty={sync:function(){},destroy:function(){}};
    if(!main || !pop || !side || !handle)return empty;
    var pointerEnabled=!!window.PointerEvent && typeof handle.setPointerCapture==='function';
    function on(el,type,fn,opts) {
      if(!el || !el.addEventListener)return;
      el.addEventListener(type,fn,opts);
      listeners.push(function(){el.removeEventListener(type,fn,opts);});
    }
    function mobile() { return window.matchMedia ? window.matchMedia('(max-width:760px)').matches : window.innerWidth<=760; }
    function inputMode() { return main.classList.contains('gio-mobile-input-active'); }
    function state() { var value=options.getState?options.getState():'balanced';return /^(collapsed|balanced|full)$/.test(value)?value:'balanced'; }
    function allowed() {
      return !disposed && mobile() && !inputMode() && main.classList.contains('tingle-modal--visible') && !handle.disabled &&
        !main.classList.contains('gio-editor-v2-is-busy') && main.getAttribute('aria-busy')!=='true' && !(options.isBusy && options.isBusy());
    }
    function pixels(value) { var number=parseFloat(value);return Number.isFinite(number)?number:0; }
    function verticalBox(style) { return pixels(style.paddingTop)+pixels(style.paddingBottom)+pixels(style.borderTopWidth)+pixels(style.borderBottomWidth); }
    function visibleChild(el) { var css=getComputedStyle(el);return !el.hidden && css.display!=='none' && css.position!=='absolute' && css.position!=='fixed'; }
    function outerHeight(el) { var css=getComputedStyle(el);return el.getBoundingClientRect().height+pixels(css.marginTop)+pixels(css.marginBottom); }
    function toggleClass(name,value) { if(main.classList.contains(name)!==!!value)main.classList.toggle(name,!!value); }
    function clearGeometry() {
      // Display enhancements never change review, save, cart, or order data.
      // The bounded CSS layouts remain usable if measurement is unavailable.
      try { pop.style.removeProperty('--gio-drawer-height');pop.style.removeProperty('--gio-stage-min-height'); } catch(error) {}
      try { main.classList.remove('gio-tools-preview-hidden','gio-tools-resizing'); } catch(error) {}
    }
    function clearClickSuppression() {
      suppressedClick=null;
      try { if(clickTimer)window.clearTimeout(clickTimer); } catch(error) {}
      clickTimer=0;
    }
    function suppressDragClick(old) {
      if(!old || !old.moved)return;
      clearClickSuppression();
      suppressedClick={id:old.id,type:old.type,source:old.source,mode:old.mode};
      // The next physical pointerdown or any keydown clears this immediately.
      // The timer only retires a record when no synthetic click was emitted.
      try { clickTimer=window.setTimeout(clearClickSuppression,500); } catch(error) {}
    }
    function stopDragMonitor() { try{if(dragFrame)cancelAnimationFrame(dragFrame);}catch(error){}dragFrame=0; }
    function detachDrag() {
      var old=drag;drag=null;stopDragMonitor();
      try { main.classList.remove('gio-tools-resizing'); } catch(error) {}
      if(old) {
        try {
          var capture=old.capture;
          if(capture && typeof capture.releasePointerCapture==='function' && (!capture.hasPointerCapture || capture.hasPointerCapture(old.id)))capture.releasePointerCapture(old.id);
        } catch(error) {}
      }
      return old;
    }
    function applyState(next) {
      if(!options.setState)return false;
      applyingState=true;
      try { options.setState(next,false); }
      finally { applyingState=false; }
      return state()===next;
    }
    function notifyUser(next,source) {
      // Preference bookkeeping is optional and cannot break the controls.
      try { if(typeof options.onUserResize==='function')options.onUserResize(next,source); } catch(error) {}
    }
    function fallback() {
      failed=true;
      var old=detachDrag();suppressDragClick(old);
      if(old)try{applyState(old.state);}catch(error){}
      clearGeometry();
    }
    // Measure surrounding controls, not the current canvas, so shrinking the
    // preview cannot feed its own result into the next layout calculation.
    function stageChrome() {
      var stage=pop.querySelector('.gio-editor-v2-stage');
      if(!stage)return 0;
      var child=stage.querySelector('.gio-design-canvas-wrap,.gio-template-canvas-wrap'), total=0;
      if(!child)return verticalBox(getComputedStyle(stage));
      total=verticalBox(getComputedStyle(child));
      while(child && child!==stage) {
        var parent=child.parentElement;if(!parent)break;
        var css=getComputedStyle(parent), count=0;
        total+=verticalBox(css)+pixels(getComputedStyle(child).marginTop)+pixels(getComputedStyle(child).marginBottom);
        Array.prototype.forEach.call(parent.children,function(sibling){
          if(!visibleChild(sibling))return;
          count++;if(sibling!==child)total+=outerHeight(sibling);
        });
        if(/^(flex|grid)$/.test(css.display))total+=Math.max(0,count-1)*pixels(css.rowGap);
        child=parent;
      }
      return total;
    }
    function bounds() {
      var css=getComputedStyle(pop), height=Math.max(0,pop.clientHeight-pixels(css.paddingTop)-pixels(css.paddingBottom)-pixels(css.rowGap));
      var bar=side.querySelector('.gio-editor-v2-drawer-bar');
      // New navigation owns both tabs and the expand button. Count it once;
      // the tabs fallback keeps this helper compatible with the older shell.
      var navigation=side.querySelector('.gio-editor-v2-tools-navigation') || side.querySelector('.gio-editor-v2-tabs');
      var low=Math.min(height,Math.ceil((bar&&visibleChild(bar)?outerHeight(bar):0)+(navigation&&visibleChild(navigation)?outerHeight(navigation):0)+verticalBox(getComputedStyle(side))));
      var hidePreview=height<280;
      var thumbnail=hidePreview?0:Math.min(120,Math.max(80,height*.18));
      var preview=hidePreview?0:Math.min(Math.max(0,height-low-120),stageChrome()+thumbnail);
      var full=Math.max(low,height-preview);
      var desired=low+Math.min(240,Math.max(180,height*.36));
      var balanced=hidePreview?full:Math.max(low,Math.min(full,desired));
      return {height:height,collapsed:low,balanced:balanced,full:full,hidePreview:hidePreview};
    }
    function put(height,b,displayState) {
      if(!Number.isFinite(height) || !Number.isFinite(b.height))throw new Error('Invalid tool layout');
      pop.style.setProperty('--gio-stage-min-height','0px');
      pop.style.setProperty('--gio-drawer-height',Math.max(b.collapsed,Math.min(b.full,height)).toFixed(2)+'px');
      toggleClass('gio-tools-preview-hidden',b.hidePreview&&displayState!=='collapsed');
    }
    function sync() {
      if(disposed)return;
      try {
        var current=state();
        handle.setAttribute('aria-expanded',String(current!=='collapsed'));
        var label=current==='full'?'Tap to expand preview':'Tap to expand tools';
        if(pointerEnabled&&!failed)label+='; or drag up and down';
        handle.setAttribute('aria-label',label);
        handle.setAttribute('title',label);
        if(drag) {
          if(!allowed()){finishDrag(false);return;}
          if(!applyingState&&current!==drag.displayState) {
            // A separate expand button may have committed a newer explicit
            // preset. Retire the old gesture without overwriting that choice.
            var retired=detachDrag();suppressDragClick(retired);sync();
          }
          return;
        }
        if(failed || !mobile() || inputMode() || !main.classList.contains('tingle-modal--visible')){clearGeometry();return;}
        if(!pop.clientHeight)return;
        var b=bounds();put(b[current],b,current);
      } catch(error) { fallback(); }
    }
    function nearest(height,b,previous) {
      var next=previous, distance=Math.abs(height-b[previous]);
      ['collapsed','balanced','full'].forEach(function(candidate){
        var difference=Math.abs(height-b[candidate]);
        if(difference<distance-.01){next=candidate;distance=difference;}
      });
      return next;
    }
    function finishDrag(commit) {
      if(!drag)return;
      var old=detachDrag();
      suppressDragClick(old);
      try {
        if(commit&&old.moved&&allowed()&&!failed) {
          var next=nearest(old.currentHeight,bounds(),old.state);
          var changed=applyState(next);sync();
          if(changed)notifyUser(next,'drag');
        } else {
          // Cancelled gestures restore the stable preset. Do not record a
          // preference for a host cancellation, busy state, close or resize.
          if(old.moved)applyState(old.state);
          sync();
        }
      } catch(error) {
        failed=true;
        try{applyState(old.state);}catch(restoreError){}
        clearGeometry();
      }
    }
    function change(next,source) {
      try {
        if(drag)finishDrag(false);
        if(!allowed())return;
        if(applyState(next)){sync();notifyUser(next,source);}
      } catch(error) { fallback(); }
    }
    function monitorDrag() {
      if(!drag || disposed)return;
      try {
        if(!allowed() || pop.clientWidth!==drag.width || pop.clientHeight!==drag.height){finishDrag(false);return;}
        if(typeof requestAnimationFrame==='function')dragFrame=requestAnimationFrame(function(){dragFrame=0;monitorDrag();});
      } catch(error) { fallback(); }
    }
    function resize(force) {
      if(disposed)return;
      if(force&&drag)finishDrag(false);
      if(resizeFrame)return;
      try {
        resizeFrame=requestAnimationFrame(function(){
          resizeFrame=0;
          try {
            var key=pop.clientWidth+':'+pop.clientHeight+':'+mobile()+':'+inputMode();
            if(key===sizeKey)return;sizeKey=key;
            if(drag&&(pop.clientWidth!==drag.width || pop.clientHeight!==drag.height || !allowed()))finishDrag(false);
            sync();
          } catch(error) { fallback(); }
        });
      } catch(error) { if(drag)finishDrag(false);sync(); }
    }
    function lifecycle() {
      if(disposed)return;
      try {
        var key=String(main.classList.contains('tingle-modal--visible'))+':'+inputMode()+':'+String(main.classList.contains('gio-editor-v2-is-busy'))+':'+main.getAttribute('aria-busy');
        // Our own resizing/preview classes must not cancel an active gesture.
        if(drag&&!allowed())finishDrag(false);
        if(key!==lifecycleKey){lifecycleKey=key;if(!drag)sync();}
      } catch(error) { fallback(); }
    }
    function hasSelection() {
      var selection=window.getSelection && window.getSelection();
      return !!(selection && !selection.isCollapsed && String(selection));
    }
    function neutralTarget(target) {
      var el=target && (target.nodeType===1?target:target.parentElement);
      if(!el || !side.contains(el) || handle.contains(el))return false;
      // Labels may activate an input; thumbnails, custom widgets and all tab
      // navigation keep their own gestures. Never turn an upload into a drag.
      var control=el.closest('button,a,input,select,textarea,label,summary,canvas,img,video,iframe,[contenteditable]:not([contenteditable="false"]),[draggable="true"],[tabindex]:not([tabindex="-1"]),'
        +'[role="button"],[role="link"],[role="slider"],[role="spinbutton"],[role="checkbox"],[role="radio"],[role="option"],[role="listbox"],[role="tab"],'
        +'.gio-editor-v2-tools-navigation,.gio-editor-v2-tabs,.gio-editor-v2-footer,.gio-editor-v2-photo-strip,.gio-design-photo-list,.gio-template-photos,[data-gio-no-drawer-drag]');
      // The containing dialog and focusable tabpanels are not controls. A
      // match outside the drawer must never disable all of its neutral areas.
      return !(control && side.contains(control));
    }
    function scrollParents(target) {
      var list=[], el=target && (target.nodeType===1?target:target.parentElement);
      while(el && el!==side) {
        var css=getComputedStyle(el);
        if(/^(auto|scroll)$/.test(css.overflowY) || el.scrollTop>0)list.push({el:el,top:el.scrollTop});
        el=el.parentElement;
      }
      return list;
    }
    function beginDrag(id,type,x,y,source,mode,capture,target) {
      if(drag || failed || !allowed() || hasSelection())return false;
      var scroll=source==='surface'?scrollParents(target):[];
      // A gesture that starts in scrolled content remains native for its whole
      // lifetime. A new downward gesture at the top can collapse the drawer.
      if(scroll.some(function(item){return item.top>1;}))return false;
      var current=state(), b=bounds(), actual=side.getBoundingClientRect().height;
      if(!Number.isFinite(actual))actual=b[current];
      if(capture)capture.setPointerCapture(id);
      drag={id:id,type:type,x:x,y:y,source:source,mode:mode,capture:capture,scroll:scroll,started:Date.now(),state:current,displayState:current,
        startHeight:Math.max(b.collapsed,Math.min(b.full,actual)),currentHeight:actual,width:pop.clientWidth,height:pop.clientHeight,moved:false,reserved:false};
      monitorDrag();return true;
    }
    function moveDrag(e,x,y) {
      if(!drag)return;
      if(!allowed() || (drag.source==='surface' && hasSelection())){finishDrag(false);return;}
      var delta=drag.y-y, horizontal=x-drag.x;
      if(!drag.moved) {
        if(drag.source==='surface' && ((!drag.reserved && Date.now()-drag.started>600) || drag.scroll.some(function(item){return Math.abs(item.el.scrollTop-item.top)>1;}))) {
          finishDrag(false);return;
        }
        if(Math.abs(horizontal)>8 && Math.abs(horizontal)>=Math.abs(delta)){finishDrag(false);return;}
        var vertical=Math.abs(delta)>=2 && Math.abs(delta)>=Math.abs(horizontal)*1.25;
        // In a fully open tool panel upward movement belongs to its native
        // scrolling. Only a fresh downward gesture at its top resizes it.
        if(drag.source==='surface' && drag.state==='full' && delta>0 && vertical){finishDrag(false);return;}
        if(Math.abs(delta)<10 || !vertical) {
          // Reserve an eligible vertical touch before the visual drag threshold.
          // Otherwise a small first move (for example 6px) scrolls the content,
          // and the next event correctly yields to that scroll but never resizes.
          // No controls or already-scrolled panels reach this local listener.
          if(drag.mode==='touch' && (vertical || drag.reserved)) {
            if(!e.cancelable){finishDrag(false);return;}
            e.preventDefault();drag.reserved=true;
          }
          return;
        }
      }
      // Non-cancelable touchmove means the browser owns this gesture already.
      // Do not move the panel while Safari is scrolling or navigating back.
      if(drag.mode==='touch' && !e.cancelable){finishDrag(false);return;}
      if(e.cancelable)e.preventDefault();
      if(!drag.moved) {
        drag.moved=true;toggleClass('gio-tools-resizing',true);
        if(drag.state==='collapsed'){drag.displayState='balanced';applyState('balanced');}
      }
      var b=bounds(), value=Math.max(b.collapsed,Math.min(b.full,drag.startHeight+delta));
      drag.currentHeight=value;put(value,b,drag.displayState);
    }
    // Explicit click/keyboard layouts are the baseline, even without Pointer
    // Events, pointer capture, observers, or successful geometry measurements.
    try {
      on(handle,'click',function(e){
        if(suppressedClick) {
          var keyboard=e.detail===0&&!e.pointerType;
          var otherPointer=e.pointerId!=null && e.pointerId!==suppressedClick.id;
          if(!keyboard&&!otherPointer) {
            clearClickSuppression();e.preventDefault();e.stopImmediatePropagation();return;
          }
          clearClickSuppression();
        }
        e.preventDefault();
        try { var current=state();change(current==='full'?'balanced':current==='collapsed'?'balanced':'full','click'); } catch(error) { fallback(); }
      });
      on(handle,'keydown',function(e){
        clearClickSuppression();
        if(!/^(ArrowUp|ArrowDown|Home|End)$/.test(e.key))return;
        e.preventDefault();
        try {
          var current=state();
          change(e.key==='Home'?'collapsed':e.key==='End'?'full':e.key==='ArrowUp'?(current==='collapsed'?'balanced':'full'):(current==='full'?'balanced':'collapsed'),'keyboard');
        } catch(error) { fallback(); }
      });
    } catch(error) { fallback(); }
    // The dedicated grip uses Pointer Events with its own touch-action:none.
    // Neutral tool surfaces use cancelable Touch Events instead: no ancestor
    // disables native scrolling, links, sliders, text selection or pinch zoom.
    if(pointerEnabled)try {
      on(handle,'pointerdown',function(e){
        clearClickSuppression();
        try {
          if(e.isPrimary===false){if(drag)finishDrag(false);return;}
          if(e.button>0)return;
          beginDrag(e.pointerId,e.pointerType||'',e.clientX,e.clientY,'handle','pointer',handle,e.target);
        } catch(error) { fallback(); }
      });
      on(side,'pointerdown',function(e){
        clearClickSuppression();
        try {
          if(e.isPrimary===false){if(drag)finishDrag(false);return;}
          if(e.pointerType==='touch' || e.button>0 || !neutralTarget(e.target) || typeof side.setPointerCapture!=='function')return;
          beginDrag(e.pointerId,e.pointerType||'',e.clientX,e.clientY,'surface','pointer',side,e.target);
        } catch(error) { fallback(); }
      });
      on(side,'pointermove',function(e){
        if(!drag || drag.mode!=='pointer' || drag.id!==e.pointerId)return;
        try { moveDrag(e,e.clientX,e.clientY); } catch(error) { fallback(); }
      });
      on(side,'pointerup',function(e){if(drag&&drag.mode==='pointer'&&drag.id===e.pointerId)finishDrag(true);});
      on(side,'pointercancel',function(e){if(drag&&drag.mode==='pointer'&&drag.id===e.pointerId)finishDrag(false);});
      on(side,'lostpointercapture',function(e){if(drag&&drag.mode==='pointer'&&drag.id===e.pointerId)finishDrag(false);});
    } catch(error) { fallback(); }
    try {
      on(side,'touchstart',function(e){
        clearClickSuppression();
        try {
          if(!e.touches || e.touches.length!==1){if(drag)finishDrag(false);return;}
          var touch=e.touches[0];
          // Reserve the native screen-edge back gesture for browser history.
          if(touch.clientX<24 || !neutralTarget(e.target))return;
          beginDrag(touch.identifier,'touch',touch.clientX,touch.clientY,'surface','touch',null,e.target);
        } catch(error) { fallback(); }
      },{passive:true});
      on(side,'touchmove',function(e){
        if(!drag || drag.mode!=='touch')return;
        try {
          if(!e.touches || e.touches.length!==1 || e.touches[0].identifier!==drag.id){finishDrag(false);return;}
          moveDrag(e,e.touches[0].clientX,e.touches[0].clientY);
        } catch(error) { fallback(); }
      },{passive:false});
      on(side,'touchend',function(e){if(drag&&drag.mode==='touch')finishDrag(!e.touches || e.touches.length===0);},{passive:true});
      on(side,'touchcancel',function(){if(drag&&drag.mode==='touch')finishDrag(false);},{passive:true});
      on(side,'click',function(e){
        if(!suppressedClick || suppressedClick.source!=='surface' || (e.detail===0&&!e.pointerType))return;
        if(suppressedClick.mode==='pointer' && e.pointerId!=null && e.pointerId!==suppressedClick.id)return;
        clearClickSuppression();e.preventDefault();e.stopImmediatePropagation();
      },true);
      on(side,'keydown',clearClickSuppression,true);
      on(window,'blur',function(){if(drag)finishDrag(false);});
    } catch(error) { fallback(); }
    try {
      if(window.ResizeObserver){observer=new ResizeObserver(function(){resize(false);});observer.observe(pop);}
      if(window.MutationObserver){lifecycleObserver=new MutationObserver(lifecycle);lifecycleObserver.observe(main,{attributes:true,attributeFilter:['class','aria-busy']});}
      on(window,'resize',function(){resize(true);},{passive:true});
      on(window,'orientationchange',function(){resize(true);},{passive:true});
    } catch(error) { fallback(); }
    sync();
    return {sync:sync,destroy:function(){
      if(disposed)return;
      if(drag)finishDrag(false);
      disposed=true;clearClickSuppression();stopDragMonitor();
      try { if(resizeFrame)cancelAnimationFrame(resizeFrame);if(observer)observer.disconnect();if(lifecycleObserver)lifecycleObserver.disconnect(); } catch(error) {}
      resizeFrame=0;
      listeners.forEach(function(remove){try{remove();}catch(error){}});listeners=[];
      clearGeometry();
    }};
  }};
}());
